import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Pencil } from "lucide-react";
import { formatAddress } from "@/lib/address";

export default function EmergencyContactCard({ contact, tid, editable }) {
  const ec = contact || {};
  const address = formatAddress(ec);
  const empty = !ec.name && !ec.phone && !ec.email && !address;
  return (
    <div className="px-4 py-3 border-b border-[#262626] bg-[#0F0F0F]" data-testid={`emergency-card-${tid}`}>
      <div className="flex items-center justify-between gap-3 mb-1.5">
        <span className="font-mono-label text-[10px] text-[#F87171]">EMERGENCY CONTACT</span>
        {editable && (
          <Link to="/wizard" data-testid={`emergency-edit-${tid}`} className="font-mono-label text-[10px] text-muted-foreground hover:text-white inline-flex items-center gap-1 transition-colors">
            <Pencil size={11} /> {empty ? "Add" : "Edit"}
          </Link>
        )}
      </div>
      {empty ? (
        <p className="text-sm text-muted-foreground" data-testid={`emergency-empty-${tid}`}>No emergency contact added yet.</p>
      ) : (
        <div className="text-sm space-y-1">
          <div className="font-semibold break-words" data-testid={`emergency-name-${tid}`}>
            {ec.name || "Unnamed contact"}{ec.relationship && <span className="text-muted-foreground font-normal"> · {ec.relationship}</span>}
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            {ec.phone && <a href={`tel:${ec.phone.replace(/[^\d+]/g, "")}`} data-testid={`emergency-phone-${tid}`} className="inline-flex items-center gap-1.5 text-[#FFD600] hover:underline"><Phone size={13} className="shrink-0" /> {ec.phone}</a>}
            {ec.email && <a href={`mailto:${ec.email}`} data-testid={`emergency-email-${tid}`} className="inline-flex items-center gap-1.5 text-[#FFD600] hover:underline break-all"><Mail size={13} className="shrink-0" /> {ec.email}</a>}
          </div>
          {address && <div className="inline-flex items-start gap-1.5 text-muted-foreground break-words" data-testid={`emergency-address-${tid}`}><MapPin size={13} className="mt-0.5 shrink-0" /> {address}</div>}
        </div>
      )}
    </div>
  );
}
